import { useSession } from "@core/hooks/useSession";
import useUser from "@core/hooks/useUser";
import ErrorScreen from "@core/layout/ErrorScreen";
import { SSRError } from "@core/types";
import { NextSeo } from "next-seo";
import { FC, useState } from "react";

import Feed from "../components/Feed";
import LoadingFeed from "../components/Feed/LoadingFeed";
import PageWrapper from "../components/PageWrapper";

export interface Props {
  segmentId?: string;
  subtypeId: string;
  title: string;
  subtypeSlug: string;
  ssrError?: SSRError;
}

const SubtypeFeedScreen: FC<Props> = ({
  segmentId,
  subtypeId,
  title,
  subtypeSlug,
  ssrError,
}) => {
  const [error, setError] = useState<Error | null>(null);
  const { data, isLoading: isLoadingSession } = useSession();
  const { data: user, isLoading: isLoadingUser } = useUser();
  const isLoading = isLoadingSession || isLoadingUser;

  const enableParentalControl = !!user?.childAdolescentViewEnabled;

  const isAuthenticated = !!data?.accessToken;

  if (error || ssrError) {
    return <ErrorScreen error={error || ssrError} />;
  }

  return (
    <>
      <NextSeo
        title={`${title} Community`}
        description={`The NOCD Community provides support for people with ${title}. You can meet others, share your experiences, and learn from others on a similar journey with ${title}.`}
        openGraph={{
          description: `The NOCD Community provides support for people with ${title}. You can meet others, share your experiences, and learn from others on a similar journey with ${title}.`,
          title: `${title} Community`,
        }}
      />

      <PageWrapper
        classes={{ container: "!pb-0" }}
        hideSidebar={enableParentalControl}
      >
        {
          // eslint-disable-next-line no-nested-ternary
          isLoading ? (
            <LoadingFeed />
          ) : error ? (
            <ErrorScreen error={error} />
          ) : (
            <div className="relative">
              <div className="space-y-3">
                <Feed
                  setError={setError}
                  segmentId={segmentId}
                  subtypeId={subtypeId}
                  isAuthenticated={isAuthenticated}
                  subtypeSlug={subtypeSlug}
                />
              </div>
            </div>
          )
        }
      </PageWrapper>
    </>
  );
};

export default SubtypeFeedScreen;
